import { render, staticRenderFns } from "./giftItem1.vue?vue&type=template&id=1a3e89b2&scoped=true"
import script from "./giftItem1.vue?vue&type=script&lang=js"
export * from "./giftItem1.vue?vue&type=script&lang=js"
import style0 from "./giftItem1.vue?vue&type=style&index=0&id=1a3e89b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3e89b2",
  null
  
)

export default component.exports